import moment from "moment";

var TimerOptionsService = {};
/**
 * 丸め込まれたスタート時間を取得します。
 * @param {*} startDate 
 */
TimerOptionsService.getStartTime = function (startDate, strideMinute) {
    var targetStartTime = moment(startDate)
        .seconds(0)
        .millisecond(0);
    var startDiff = targetStartTime.minute() % strideMinute;
    if (startDiff) {
        targetStartTime.add(strideMinute - startDiff, "m");
    }
    return targetStartTime;
}
/**
 * 丸め込まれた終了時間を取得します。
 * @param {*} startDate 
 */
TimerOptionsService.getEndTime = function (limitTime, strideMinute) {
    var targetEndTime = moment(limitTime)
        .seconds(0)
        .millisecond(0);
    // 終了時間は現在時刻の次の15分(strideMinute)刻みの値へ繰下げる
    // 例)5分 => 0分 0分 => 0分 16分 => 15分
    var endDiff = targetEndTime.minute() % strideMinute;
    targetEndTime.add(-1 * endDiff, "m");
    return targetEndTime;
}
TimerOptionsService.getSeleteableTimes = function (startTime, limitTime, strideMinute = 15, maxSection = 4) {
    if (startTime > limitTime) {
        new Error("入力値が不正です。");
    }
    var startDate = startTime ? startTime : new Date();
    var targetStartTime = TimerOptionsService.getStartTime(startDate, strideMinute);
    var targetEndTime = TimerOptionsService.getEndTime(limitTime, strideMinute);
    // 何セクション可能かを計算
    var diffMin =
        targetEndTime.diff(targetStartTime, "minutes") / strideMinute;
    var sectionNum = diffMin > maxSection ? maxSection : diffMin;
    var candidates = []
    for (var i = 1; i <= sectionNum; i++) {
        candidates.push({
            key: i,
            value: moment(targetStartTime.toDate()).add(
                strideMinute * i,
                "m"
            )
        });
    }
    return candidates;
}
export default TimerOptionsService;